import { render, staticRenderFns } from "./StartupModal.vue?vue&type=template&id=a2582c46&scoped=true&"
import script from "./StartupModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2582c46",
  null
  
)

export default component.exports